import React, { Component } from "react";
import { observer } from "mobx-react";
import { Link } from "react-router-dom";
import { AxiosResponse } from "axios";
import { getRequest, postRequest } from "../../utils/httpRequest";
import { Courses } from "../Home/components";
import TeamHeader from "./Header";
import Podium from "./Podium";
import TeamInsights from "./TeamInsights";
import { TeamState } from "../../stores/TeamStore/Types";
import { CurrentUser } from "../../stores/CurrentUserStore/Types";
import { Hero } from "./Leaderboard/Types";
import TeamStore from "../../stores/TeamStore";
import TeamReactions from "../../stores/TeamStore/TeamReactions";
import Settings from "./Settings";
import Leaderboard from "./Leaderboard";

interface Props {
  getCurrentUser: () => void;
  currentUser: CurrentUser;
  match: any;
}

interface State {
  showSettingsModal: boolean;
  heroes: Hero[];
}

interface Response {
  heroes: Hero[];
  total_pages: number;
}

class TeamManagement extends Component<Props, State> {
  teamStore = new TeamStore();

  constructor(props) {
    super(props);

    this.state = {
      showSettingsModal: false,
      heroes: []
    };
  }

  componentDidMount() {
    this.teamStore.loading();
    this.getHeroes();
  }

  getHeroes = () => {
    return getRequest(
      `/api/teams/${this.props.match.params.slug}/leaderboard_search.json?count=20`
    ).then((response: AxiosResponse<Response>) => {
      const { data } = response;

      let heroes = data.heroes.map(hero => {
        return { ...hero, selected: false };
      });

      this.setState({
        heroes
      });
    });
  };

  updateHeroes = heroes => {
    this.setState({ heroes });
  };

  handleShowSettingsModal = val => this.setState({ showSettingsModal: val });

  renderContent = (teamState: TeamState) => {
    const { currentUser } = this.props;
    const { showSettingsModal } = this.state;

    switch (teamState.kind) {
      case "ready":
        return (
          <>
            <TeamHeader
              teamResource={teamState.teamResource}
              handleShowSettingsModal={this.handleShowSettingsModal}
            />

            <div className="team-manage__top">
              <div className="container">
                {/* The podium takes the full width on its own when a team is
                    too small to have three on the board. */}
                <div className="top-zone">
                  <Podium heroes={this.state.heroes} />
                  <TeamInsights
                    slug={this.props.match.params.slug}
                    fact={teamState.teamResource.zen_pool}
                    userIsInUk={currentUser?.is_in_uk}
                  />
                </div>
              </div>
            </div>

            <Leaderboard
              slug={this.props.match.params.slug}
              heroes={this.state.heroes}
              updateHeroes={this.updateHeroes}
            />

            <Settings
              showSettingsModal={showSettingsModal}
              teamResource={teamState.teamResource}
              handleShowSettingsModal={this.handleShowSettingsModal}
              teamStore={this.teamStore}
              getHeroes={this.getHeroes}
            />
          </>
        );
      case "loading":
        return (
          <div className="ui active inverted dimmer">
            <div className="ui text loader">Loading</div>
          </div>
        );

      default:
        return <div />;
        break;
    }
  };

  render() {
    const { state } = this.teamStore;

    return (
      // facelift-profile-page is kept deliberately: it's the scope that holds
      // the brand tokens and the shared .home-header band this page borrows
      // from the logged-in profile. The old profile-header-wrapper is not --
      // that carried the previous two-column layout's spacing.
      <main className="facelift-profile-page team-manage">
        {this.renderContent(state)}
        <TeamReactions
          store={this.teamStore}
          slug={this.props.match.params.slug}
        />
      </main>
    );
  }
}

export default observer(TeamManagement);
